var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 10.7084C4.375 9.93481 4.68229 9.19294 5.22927 8.64596C5.77625 8.09898 6.51812 7.79169 7.29167 7.79169H27.7083C28.4819 7.79169 29.2237 8.09898 29.7707 8.64596C30.3177 9.19294 30.625 9.93481 30.625 10.7084M4.375 10.7084V25.2917C4.375 26.0652 4.68229 26.8071 5.22927 27.3541C5.77625 27.9011 6.51812 28.2084 7.29167 28.2084H27.7083C28.4819 28.2084 29.2237 27.9011 29.7707 27.3541C30.3177 26.8071 30.625 26.0652 30.625 25.2917V10.7084M4.375 10.7084L17.5 19.4584L30.625 10.7084",
    stroke: "white",
    strokeWidth: 3.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.070554943c67ed983181eab2f2126d0a.svg";
export { ForwardRef as ReactComponent };